export default {
  description:
    'Carregue os documentos necessários para verificar a sua empresa. Os documentos obrigatórios estão assinalados; pode adicionar os opcionais agora ou mais tarde.',
  missing_one: 'Ainda falta um documento obrigatório. Pode continuar: este passo mantém-se aberto até ser carregado.',
  missing_other:
    'Ainda faltam {{count}} documentos obrigatórios. Pode continuar: este passo mantém-se aberto até serem carregados.',
  buttons: {
    back: 'Voltar',
    next: 'Seguinte',
    finish_later: 'Terminar mais tarde',
  },
};
